import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeAdminOption } from 'src/types/shared/AdminUser';

export const populateChallengeGroupAdminsRequest = createAction(
    'populateChallengeGroupAdminsRequest',
);
export const populateChallengeGroupAdminsSuccess = createAction<ChallengeAdminOptionPayload>(
    'populateChallengeGroupAdminsSuccess',
);
export const populateChallengeGroupAdminsFailure = createAction(
    'populateChallengeGroupAdminsFailure',
);

export const populateChallengeGroupAdmins = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(populateChallengeGroupAdminsRequest());
    try {
        const { data } = await api.get<ChallengeAdminOptionPayload>(
            `admin/challengegroups/${challengeID}/edit-challenge-admins`,
        );
        dispatch(populateChallengeGroupAdminsSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, populateChallengeGroupAdminsFailure, e);
    }
};

export interface ChallengeAdminOptionPayload {
    users: ChallengeAdminOption[];
}
